export const RECAPTCHA_CONTAINER_ID = 'recaptcha-container-contact';
export const RECAPTCHA_TYPE = 'normal';
